import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICompanyFile } from '@leedpulse-monorepo/interfaces';

async function getCompanyFiles(
  companyId: string,
  pageSize: number,
  page: number,
  auth: Authentication | null
): Promise<{
  items: ICompanyFile[];
  totalCount: number;
}> {
  try {
    if (!auth) throw new GetCompanyFilesFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const query = new URLSearchParams({ pageSize: String(pageSize), page: String(page) });

    const response = await HttpClient.get(
      `/backoffice/companies/${companyId}/files?${query.toString()}`,
      auth.token
    );

    if (!response.success) throw new GetCompanyFilesFailure(response.message, response.code);
    return response.data;
  } catch (e) {
    if (e instanceof GetCompanyFilesFailure) throw e;
    throw new GetCompanyFilesFailure();
  }
}

export class GetCompanyFilesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompanyFiles;
